import React from 'react';
import { Modal,Button,Panel,ButtonGroup,PanelGroup} from 'rsuite';
class HelpPanel extends React.Component {
    constructor(props) {
      super(props);
      this.state={
        picLink:[
            "assets/pic/helpPanel/step1.jpg",
            "assets/pic/helpPanel/step2.jpg",
            "assets/pic/helpPanel/step3.jpg",
            "assets/pic/helpPanel/step4.jpg",
            "assets/pic/helpPanel/step5.jpg",
            "assets/pic/helpPanel/step6.jpg",
            "assets/pic/helpPanel/step8.jpg",
        ],
        teachUsePicLink:[
            "assets/pic/helpPanel/tstep1.jpg",
            "assets/pic/helpPanel/tstep2.jpg",
            "assets/pic/helpPanel/tstep3.jpg",
        ]

        }
    }
    returnPanel=()=>{
          return(
            <PanelGroup>
              <Panel header="1.地质模型选择" bordered>
              左边导航条打开操作面板，选择步骤一，在已有的地质模型中选择不同的地质环境作为工程场地。
              <img
                src={this.state.picLink[0]}
                alt=""
                title="步骤一"
                style={{maxWidth: "100%"}}
                />
              </Panel>
              <Panel header="2.电极布置" bordered>
              根据测量任务，在3D地质模型上绘制具体的测量剖线与电极测点，
              布置要求避开地形切割大的区域、陡坎、断崖、水塘、河流等。
              <img
                src={this.state.picLink[1]}
                alt=""
                title="步骤二"
                style={{maxWidth: "100%"}}
                />
              </Panel>
              <Panel header="3.电极连接" bordered>
              在模拟的3D仪器面板图中正确连接电极线及ABMN的接线。
              <img
                src={this.state.picLink[2]}
                alt=""
                title="步骤三"
                style={{maxWidth: "100%"}}
                />
              </Panel>
              <Panel header="4.测量参数设定" bordered>
              设定每一个选定测量装置的具体参数，
              如电极点距，存储序号，画图比例，
              最小间隔系数，最大间隔系数，开始电极序号，
              排列电极总数，温施间隔层数等。
              <img
                src={this.state.picLink[3]}
                alt=""
                title="步骤四"
                style={{maxWidth: "100%"}}
                />
              </Panel>
              <Panel header="5.测量" bordered>
              按测量按钮开始测量，测量过程中以3D动画的形式显示测量电极的转换过程
              <img
                src={this.state.picLink[4]}
                alt=""
                title="步骤五"
                style={{maxWidth: "100%"}}
                />
              </Panel>
              <Panel header="6.下载测量结果" bordered>
              测量完成后显示测量结果，
              测量结果以断面图的形式显示处理。
              点击下载按钮下载测量结果到本地，
              供进一步的数据处理使用。
              <img
                src={this.state.picLink[5]}
                alt=""
                title="步骤六"
                style={{maxWidth: "100%"}}
                />
              </Panel>
              <Panel header="7.数据解释" bordered>
              对反演的结果进行解释。
              </Panel>
              </PanelGroup>
          );
      }
    render() {
        return (
            <Modal show={this.props.showuse} onHide={this.props.useclose}  overflow>
                <Modal.Header>
                    <Modal.Title>
                    使用说明
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                {this.returnPanel()}
                </Modal.Body>
            </Modal>
        )
        
    }
}
export default HelpPanel;